<script setup>
import { ref, watch, computed, onMounted } from "vue";
import {
  Chart,
  LineElement,
  PointElement,
  LineController,
  LinearScale,
  CategoryScale,
  Tooltip,
  Legend,
  Filler
} from "chart.js";

const props = defineProps({
  data: {
    type: Object,
    required: true,
  },
  xTitle: {
    type: String,
    default: 'Fecha'
  },
  yTitle: {
    type: String,
    default: 'Colaboradores'
  }
});

const root = ref(null);
let chart = null;

Chart.register(
  LineElement,
  PointElement,
  LineController,
  LinearScale,
  CategoryScale,
  Tooltip,
  Legend,
  Filler
);

onMounted(() => {
  chart = new Chart(root.value, {
    type: "line",
    data: props.data,
    options: {
      responsive: true,
      maintainAspectRatio: false,
      interaction: {
        mode: 'index',
        intersect: false,
      },
      scales: {
        y: {
          display: true,
          beginAtZero: true,
          title: {
            display: !!props.yTitle,
            text: props.yTitle,
            font: { size: 11, weight: 'bold' }
          },
          grid: {
            color: 'rgba(226, 232, 240, 0.6)'
          }
        },
        x: {
          display: true,
          title: {
            display: !!props.xTitle,
            text: props.xTitle,
            font: { size: 11, weight: 'bold' }
          },
          ticks: {
            maxRotation: 45,
            minRotation: 30,
            font: { size: 9 }
          },
          grid: {
            color: 'rgba(226, 232, 240, 0.4)'
          }
        },
      },
      plugins: {
        legend: {
          display: true,
          position: 'top',
          labels: {
            boxWidth: 16,
            font: { size: 11, weight: '600' }
          }
        },
        tooltip: {
          padding: 10,
          cornerRadius: 8
        }
      },
    },
  });
});

const chartData = computed(() => props.data);

watch(chartData, (newData) => {
  if (chart) {
    chart.data = newData;
    chart.update();
  }
});
</script>

<template>
  <canvas ref="root" />
</template>
